import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableBoolean, nullableString } from '../utils/wire-value-utils';
import { InvitationEmailStatus } from './invitation-email-status.model';

/**
 * A profile invitation as `/admin/invitations` returns it (hub `toAdminProfileInvitationResponse`,
 * `ADMIN_PROFILE_INVITATION_READABLE`). The hub never returns the token, metadata, profileUuid or actor ids.
 */
export class ProfileInvitation extends Base {
  organizationId?: string | null;
  invitationType?: string | null;
  isAccepted?: boolean | null;
  isCancelled?: boolean | null;
  /** ISO timestamps as sent by the hub. */
  tokenExpiresAt?: string | null;
  lastResentAt?: string | null;
  emailSentAt?: string | null;
  resendCount: number;
  emailStatus?: InvitationEmailStatus | null;
  emailError?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.organizationId = nullableString(source['organizationId']);
    this.invitationType = nullableString(source['invitationType']);
    this.isAccepted = nullableBoolean(source['isAccepted']);
    this.isCancelled = nullableBoolean(source['isCancelled']);
    this.tokenExpiresAt = nullableString(source['tokenExpiresAt']);
    this.lastResentAt = nullableString(source['lastResentAt']);
    this.emailSentAt = nullableString(source['emailSentAt']);
    this.resendCount = countOrZero(source['resendCount']);
    this.emailStatus = nullableString(source['emailStatus']) as InvitationEmailStatus | null | undefined;
    this.emailError = nullableString(source['emailError']);
  }
}
